import { useState } from "react";
import * as usersService from "../../utilities/users-service";
import { useNavigate } from "react-router-dom";

export default function LoginForm({ setUser }) {
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  function handleChange(evt) {
    setCredentials({ ...credentials, [evt.target.name]: evt.target.value });
    setError("");
  }

  async function handleSubmit(evt) {
    // Prevent form from being submitted to the server
    evt.preventDefault();
    try {
      // The promise returned by the signUp service method
      // will resolve to the user object included in the
      // payload of the JSON Web Token (JWT)
      const user = await usersService.login(credentials);
      setUser(user);
      navigate("/");
    } catch {
      setError("Log in failed — try again");
      navigate("/");
    }
  }

  return (
    <div>
      <form autoComplete="off" onSubmit={handleSubmit} className="space-y-6">
        <div>
          <input
            type="text"
            name="email"
            placeholder="Email"
            value={credentials.email}
            onChange={handleChange}
            required
            className="w-full border-b border-gray-300 bg-transparent py-2 text-sm text-gray-900 placeholder-gray-400 outline-none transition-colors focus:border-gray-900"
          />
        </div>
        <div>
          <input
            type="password"
            name="password"
            placeholder="Password"
            value={credentials.password}
            onChange={handleChange}
            required
            className="w-full border-b border-gray-300 bg-transparent py-2 text-sm text-gray-900 placeholder-gray-400 outline-none transition-colors focus:border-gray-900"
          />
        </div>
        <button
          type="submit"
          className="w-full rounded-lg bg-gray-900 py-3 text-sm font-medium text-white transition-colors hover:bg-gray-700"
        >
          Log in
        </button>
      </form>
      {error && (
        <p className="mt-4 text-center text-xs text-red-500">{error}</p>
      )}
    </div>
  );
}
